import { useDemand } from "lib/authorization/use-demand"

export function NotInSharing({ children = null }) {
    const notSharing = useDemand("!sharing")
    return notSharing && children
}
